module.exports = __webpack_public_path__ + "img/species-spotlight.80989b95.jpeg";